export default __webpack_public_path__ + "static/media/radio-unchecked.ccc78151.svg";